import { z } from 'zod';

import { schemaSlaceConversation } from './SlaceConversation';

// https://docs.slace.com/docs/stoplight-docs-core/47644ee888e8f-communication-channel
export const schemaSlaceCommunicationChannel = z.object({
    contact_id: z.string().optional(),
    conversations: z.array(schemaSlaceConversation).optional(),
    created_at: z.string(),
    id: z.string(),
    messenger_id: z.string(),
    messenger_type: z.enum([
        'WhatsApp',
        'TelegramBot',
        'Webchat',
        'ViberChatbots',
        'FacebookMessenger',
        'InstagramMessenger',
        'SMS',
        'GoogleBM',
    ]),
    name: z.string(),
    organization_id: z.string(),
    permission: z.record(z.unknown()).optional(),
    profile_photo: z.string().optional(),
    type: z.enum(['unknown', 'person', 'group', 'channel']),
    updated_at: z.string(),
});

export type SchemaSlaceCommunicationChannel = z.infer<typeof schemaSlaceCommunicationChannel>;
